module.exports = __webpack_public_path__ + "images/91e23124601f7f7c2dfc008d092f90b9-cs2.jpg";